import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type dldsCredType = CarrierLogisticsCredType
export const dldsDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const dlds: CarrierDef<dldsCredType> = {
  name: 'Diamond Line Delivery Systems',
  scac: 'dlds',
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'pickup', 'tracking', 'profinder'],
  documentTypes: dldsDocumentTypes,
}
